// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/back.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.album-page {
  min-height: 100vh;
  position: relative;
  z-index: 2;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment: fixed;
}

/* 上半部分 - 透明区域 */
.album-top-section {
  min-height: 40vh;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 20px 40px;
  position: relative;
}

.album-top-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to bottom, 
    rgba(255, 182, 193, 0.6) 0%, 
    rgba(255, 192, 203, 0.5) 20%,
    rgba(255, 218, 224, 0.4) 50%,
    rgba(255, 240, 245, 0.3) 80%, 
    rgba(255, 255, 255, 0.2) 100%);
  z-index: 1;
}

.album-top-section > * {
  position: relative;
  z-index: 2;
}

/* 波浪线分割 */
.album-wave-divider {
  width: 100%;
  height: 180px;
  overflow: hidden;
  position: relative;
  z-index: 3;
  background: transparent;
  margin-top: -50px;
}

.album-wave-divider svg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 180px;
}

/* 下半部分 - 从下方粉色到中间白色渐变 */
.album-bottom-section {
  min-height: 60vh;
  background: linear-gradient(to top, 
    rgba(255, 182, 193, 0.9) 0%, 
    rgba(255, 192, 203, 0.8) 20%, 
    rgba(255, 205, 215, 0.7) 45%, 
    rgba(255, 228, 235, 0.5) 75%, 
    rgba(255, 240, 245, 0.4) 100%
  );
  padding: 40px 20px;
  position: relative;
}

.album-container {
  max-width: 1200px;
  margin: 0 auto;
}

.album-header {
  text-align: center;
  margin-bottom: 40px;
}

.back-btn {
  position: absolute;
  top: 20px;
  left: 20px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  color: white;
  text-decoration: none;
  padding: 12px 20px;
  border-radius: 25px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

.album-title {
  font-size: 3.5rem;
  font-weight: 700;
  background: linear-gradient(45deg, #ff69b4, #ff1493, #dc143c);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  text-shadow: 0 4px 8px rgba(255, 105, 180, 0.3);
}

.title-icon {
  color: #ff69b4;
  filter: drop-shadow(0 2px 4px rgba(255, 105, 180, 0.5));
  animation: heartbeat 2s ease-in-out infinite;
}

@keyframes heartbeat {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

.album-subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.1rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.photo-stats {
  display: flex;
  justify-content: center;
  gap: 60px;
  margin-bottom: 40px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 30px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.stat-item {
  text-align: center;
  color: white;
}

.stat-number {
  display: block;
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(45deg, #ff69b4, #ff1493);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin-bottom: 5px;
  text-shadow: 0 2px 4px rgba(255, 105, 180, 0.3);
}

.stat-label {
  font-size: 1rem;
  opacity: 0.8;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 25px;
  margin-bottom: 50px;
}

.photo-item {
  cursor: pointer;
  transition: all 0.3s ease;
}

.photo-wrapper {
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.2);
  aspect-ratio: 4/3;
}

.photo-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all 0.3s ease;
}

.photo-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.3) 70%,
    rgba(0, 0, 0, 0.8) 100%
  );
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  opacity: 0;
  transition: all 0.3s ease;
}

.photo-item:hover .photo-overlay {
  opacity: 1;
}

.photo-item:hover .photo-image {
  transform: scale(1.1);
}

.expand-icon {
  color: white;
  font-size: 1.5rem;
  background: rgba(255, 255, 255, 0.2);
  padding: 10px;
  border-radius: 50%;
  backdrop-filter: blur(10px);
}

.photo-info {
  text-align: center;
  color: white;
  width: 100%;
}

.photo-title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 8px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.photo-date {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-size: 0.9rem;
  opacity: 0.9;
}

.album-footer {
  text-align: center;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 25px;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.love-message {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 1.2rem;
  color: white;
  font-weight: 500;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.heart-icon {
  color: #ff69b4;
  animation: heartbeat 2s ease-in-out infinite;
}

@keyframes heartbeat {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

/* 模态框样式 */
.photo-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.photo-detail {
  position: relative;
  max-width: 90vw;
  max-height: 90vh;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(15px);
  border-radius: 25px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  flex-direction: column;
}

.close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 18px;
  z-index: 10;
  transition: all 0.3s ease;
}

.close-btn:hover {
  background: rgba(0, 0, 0, 0.8);
  transform: scale(1.1);
}

.photo-navigation {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  z-index: 10;
  pointer-events: none;
}

.nav-btn {
  background: rgba(0, 0, 0, 0.5);
  border: none;
  color: white;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 24px;
  font-weight: bold;
  transition: all 0.3s ease;
  pointer-events: all;
}

.nav-btn:hover {
  background: rgba(0, 0, 0, 0.8);
  transform: scale(1.1);
}

.detail-image-wrapper {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.detail-image {
  max-width: 100%;
  max-height: 60vh;
  object-fit: contain;
  border-radius: 10px;
}

.detail-info {
  padding: 30px;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  color: white;
}

.detail-title {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 15px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

.detail-meta {
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
  font-size: 0.9rem;
  opacity: 0.9;
}

.detail-date {
  display: flex;
  align-items: center;
  gap: 5px;
}

.detail-description {
  font-size: 1.1rem;
  line-height: 1.6;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .photo-grid {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 20px;
  }
  
  .album-title {
    font-size: 2rem;
  }
  
  .photo-stats {
    gap: 30px;
    padding: 20px;
  }
  
  .stat-number {
    font-size: 2rem;
  }
  
  .photo-detail {
    max-width: 95vw;
    max-height: 95vh;
  }
  
  .detail-info {
    padding: 20px;
  }
  
  .detail-title {
    font-size: 1.5rem;
  }
  
  .nav-btn {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
}

@media (max-width: 480px) {
  .album-page {
    padding: 10px;
  }
  
  .back-btn {
    position: relative;
    top: auto;
    left: auto;
    margin-bottom: 20px;
    display: inline-flex;
  }
  
  .photo-grid {
    grid-template-columns: 1fr;
  }
  
  .album-title {
    font-size: 1.8rem;
  }
  
  .photo-stats {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
  
  .stat-item {
    padding: 10px;
  }
  
  .detail-meta {
    flex-direction: column;
    gap: 10px;
  }
  
  .love-message {
    font-size: 1rem;
    gap: 8px;
  }
}


`, "",{"version":3,"sources":["webpack://./src/pages/AlbumPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,yDAA2C;EAC3C,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;kCAKgC;EAChC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA,UAAU;AACV;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,aAAa;AACf;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB;;;;;;GAMC;EACD,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,qCAAqC;EACrC,2BAA2B;EAC3B,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,uDAAuD;EACvD,4CAA4C;AAC9C;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,qBAAqB,EAAE;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;EACpC,2BAA2B;EAC3B,0CAA0C;EAC1C,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;GAKC;EACD,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;EACb,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,qBAAqB,EAAE;AAC/B;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA,UAAU;AACV;EACE;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;AACF","sourcesContent":[".album-page {\n  min-height: 100vh;\n  position: relative;\n  z-index: 2;\n  background-image: url('../assets/back.jpg');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n}\n\n/* 上半部分 - 透明区域 */\n.album-top-section {\n  min-height: 40vh;\n  background: transparent;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px 40px;\n  position: relative;\n}\n\n.album-top-section::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(to bottom, \n    rgba(255, 182, 193, 0.6) 0%, \n    rgba(255, 192, 203, 0.5) 20%,\n    rgba(255, 218, 224, 0.4) 50%,\n    rgba(255, 240, 245, 0.3) 80%, \n    rgba(255, 255, 255, 0.2) 100%);\n  z-index: 1;\n}\n\n.album-top-section > * {\n  position: relative;\n  z-index: 2;\n}\n\n/* 波浪线分割 */\n.album-wave-divider {\n  width: 100%;\n  height: 180px;\n  overflow: hidden;\n  position: relative;\n  z-index: 3;\n  background: transparent;\n  margin-top: -50px;\n}\n\n.album-wave-divider svg {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 180px;\n}\n\n/* 下半部分 - 从下方粉色到中间白色渐变 */\n.album-bottom-section {\n  min-height: 60vh;\n  background: linear-gradient(to top, \n    rgba(255, 182, 193, 0.9) 0%, \n    rgba(255, 192, 203, 0.8) 20%, \n    rgba(255, 205, 215, 0.7) 45%, \n    rgba(255, 228, 235, 0.5) 75%, \n    rgba(255, 240, 245, 0.4) 100%\n  );\n  padding: 40px 20px;\n  position: relative;\n}\n\n.album-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.album-header {\n  text-align: center;\n  margin-bottom: 40px;\n}\n\n.back-btn {\n  position: absolute;\n  top: 20px;\n  left: 20px;\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  color: white;\n  text-decoration: none;\n  padding: 12px 20px;\n  border-radius: 25px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.back-btn:hover {\n  background: rgba(255, 255, 255, 0.25);\n  transform: translateY(-2px);\n}\n\n.album-title {\n  font-size: 3.5rem;\n  font-weight: 700;\n  background: linear-gradient(45deg, #ff69b4, #ff1493, #dc143c);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 15px;\n  text-shadow: 0 4px 8px rgba(255, 105, 180, 0.3);\n}\n\n.title-icon {\n  color: #ff69b4;\n  filter: drop-shadow(0 2px 4px rgba(255, 105, 180, 0.5));\n  animation: heartbeat 2s ease-in-out infinite;\n}\n\n@keyframes heartbeat {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.1); }\n}\n\n.album-subtitle {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 1.1rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.photo-stats {\n  display: flex;\n  justify-content: center;\n  gap: 60px;\n  margin-bottom: 40px;\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 30px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.stat-item {\n  text-align: center;\n  color: white;\n}\n\n.stat-number {\n  display: block;\n  font-size: 2.5rem;\n  font-weight: 700;\n  background: linear-gradient(45deg, #ff69b4, #ff1493);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  margin-bottom: 5px;\n  text-shadow: 0 2px 4px rgba(255, 105, 180, 0.3);\n}\n\n.stat-label {\n  font-size: 1rem;\n  opacity: 0.8;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.photo-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 25px;\n  margin-bottom: 50px;\n}\n\n.photo-item {\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.photo-wrapper {\n  position: relative;\n  border-radius: 20px;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 8px 25px rgba(255, 105, 180, 0.2);\n  aspect-ratio: 4/3;\n}\n\n.photo-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: all 0.3s ease;\n}\n\n.photo-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0) 0%,\n    rgba(0, 0, 0, 0.3) 70%,\n    rgba(0, 0, 0, 0.8) 100%\n  );\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  opacity: 0;\n  transition: all 0.3s ease;\n}\n\n.photo-item:hover .photo-overlay {\n  opacity: 1;\n}\n\n.photo-item:hover .photo-image {\n  transform: scale(1.1);\n}\n\n.expand-icon {\n  color: white;\n  font-size: 1.5rem;\n  background: rgba(255, 255, 255, 0.2);\n  padding: 10px;\n  border-radius: 50%;\n  backdrop-filter: blur(10px);\n}\n\n.photo-info {\n  text-align: center;\n  color: white;\n  width: 100%;\n}\n\n.photo-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 8px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);\n}\n\n.photo-date {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 5px;\n  font-size: 0.9rem;\n  opacity: 0.9;\n}\n\n.album-footer {\n  text-align: center;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 25px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.love-message {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  font-size: 1.2rem;\n  color: white;\n  font-weight: 500;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.heart-icon {\n  color: #ff69b4;\n  animation: heartbeat 2s ease-in-out infinite;\n}\n\n@keyframes heartbeat {\n  0%, 100% { transform: scale(1); }\n  50% { transform: scale(1.1); }\n}\n\n/* 模态框样式 */\n.photo-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.95);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.photo-detail {\n  position: relative;\n  max-width: 90vw;\n  max-height: 90vh;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(15px);\n  border-radius: 25px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  display: flex;\n  flex-direction: column;\n}\n\n.close-btn {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  background: rgba(0, 0, 0, 0.5);\n  border: none;\n  color: white;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 18px;\n  z-index: 10;\n  transition: all 0.3s ease;\n}\n\n.close-btn:hover {\n  background: rgba(0, 0, 0, 0.8);\n  transform: scale(1.1);\n}\n\n.photo-navigation {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  display: flex;\n  justify-content: space-between;\n  padding: 0 20px;\n  z-index: 10;\n  pointer-events: none;\n}\n\n.nav-btn {\n  background: rgba(0, 0, 0, 0.5);\n  border: none;\n  color: white;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 24px;\n  font-weight: bold;\n  transition: all 0.3s ease;\n  pointer-events: all;\n}\n\n.nav-btn:hover {\n  background: rgba(0, 0, 0, 0.8);\n  transform: scale(1.1);\n}\n\n.detail-image-wrapper {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n}\n\n.detail-image {\n  max-width: 100%;\n  max-height: 60vh;\n  object-fit: contain;\n  border-radius: 10px;\n}\n\n.detail-info {\n  padding: 30px;\n  background: rgba(0, 0, 0, 0.3);\n  backdrop-filter: blur(10px);\n  color: white;\n}\n\n.detail-title {\n  font-size: 1.8rem;\n  font-weight: 700;\n  margin-bottom: 15px;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);\n}\n\n.detail-meta {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 15px;\n  font-size: 0.9rem;\n  opacity: 0.9;\n}\n\n.detail-date {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.detail-description {\n  font-size: 1.1rem;\n  line-height: 1.6;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .photo-grid {\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n    gap: 20px;\n  }\n  \n  .album-title {\n    font-size: 2rem;\n  }\n  \n  .photo-stats {\n    gap: 30px;\n    padding: 20px;\n  }\n  \n  .stat-number {\n    font-size: 2rem;\n  }\n  \n  .photo-detail {\n    max-width: 95vw;\n    max-height: 95vh;\n  }\n  \n  .detail-info {\n    padding: 20px;\n  }\n  \n  .detail-title {\n    font-size: 1.5rem;\n  }\n  \n  .nav-btn {\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .album-page {\n    padding: 10px;\n  }\n  \n  .back-btn {\n    position: relative;\n    top: auto;\n    left: auto;\n    margin-bottom: 20px;\n    display: inline-flex;\n  }\n  \n  .photo-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .album-title {\n    font-size: 1.8rem;\n  }\n  \n  .photo-stats {\n    flex-direction: column;\n    gap: 20px;\n    text-align: center;\n  }\n  \n  .stat-item {\n    padding: 10px;\n  }\n  \n  .detail-meta {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .love-message {\n    font-size: 1rem;\n    gap: 8px;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
